<style scope>
.sweet-modal.is-mobile-fullscreen .sweet-buttons {
  bottom: unset;
}
.radio-row {
  //float: left;
  //clear: none;
  display: inline-flex;
  line-height: 1.5;
  width: 100%;
}

label {
  //float: left;
  //clear: none;
  //display: block;
  padding: 0px 0.5em 0px 5px;
}

input[type=radio],
input.radio {
  //display: table-cell;
  //vertical-align: middle;
  //float: left;
  //clear: none;
  //margin: 2px 0 0 2px;
}
</style>

<template lang="pug">
  sweet-modal(:title="'Изменить баланс для ' + email" ref="modal" @close="closed")
    ValidationObserver(ref="validator" v-slot="{ invalid, touched, passed }")
      .radio-row
        label(for="balanceIncrease") Увеличить на (+)
        input(
            type="radio"
            id="balanceIncrease"
            value="+"
            v-model="action"
          )
      .radio-row
        label(for="balanceDecrease") Уменьшить на (-)
        input(
          type="radio"
          id="balanceDecrease"
          value="-"
          v-model="action"
        )
      .radio-row
        label(for="balanceEquals") Присвоить (=)
        input(
          type="radio"
          id="balanceEquals"
          value="="
          v-model="action"
        )
      .radio-row
        ValidationProvider(:rules="{ regex: /^[1-9]{1}\\d*(\\.\\d{1,2})?$/ }" v-slot="{ errors }")
          input.form__input(
            type="text"
            v-model="value"
          )
          span.form-error {{ errors [0] }}
      button(slot="button" @click="close").btn.btn--small-fnt {{ cancelLabel }}
      button(v-promise-btn slot="button" @click="confirm" :disabled="!passed").btn.btn--small-fnt.btn--accent {{ confirmLabel }}
</template>

<script>

import apiClient from '@/apiClient';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { regex } from 'vee-validate/dist/rules';

extend('regex', {
  ...regex,
  message: 'Введите сумму, например: 123 или 123.99'
});

export default {
  name: 'BalanceModal',
  props: {
    title: {
      required: true,
      type: String
    },
    email: {
      required: true,
      type: String
    },
    firmId: {
      required: true,
      type: Number
    },
    confirmLabel: {
      required: false,
      type: String,
      default: 'Подтвердить'
    },
    cancelLabel: {
      required: false,
      type: String,
      default: 'Отменить'
    }
  },
  data: function() {
    return {
      action: '+',
      value: ''
    };
  },

  methods: {
    open() {
      this.$refs.modal.open();
    },
    close() {
      this.$refs.modal.close();
    },
    closed() {
      this.$refs.validator.reset();
      this.value = '';
      this.action = '+';
    },
    confirm() {
      return new Promise((resolve, reject) => {
        apiClient
          .put(`/firms/${this.firmId}/billings/balance`, {
            value: this.value,
            action: this.action
          })
          .then(response => {
            this.flashSuccess('Баланс успешно изменён');
            this.$emit('confirm', this.firmId, this.action, this.value);
            this.close();
            resolve(response);
          })
          .catch(err => {
            this.flashError('Возникла ошибка');
            console.log(err);
            reject(err);
          });
      });
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider
  }
};
</script>
